import { Validators } from '@angular/forms';

export const updateGroupControlsConfig = {
    name: ['', Validators.required],
    parentId: [''],
    id: ['', Validators.required],
    type: ['', Validators.required],
};

